module.exports = __webpack_public_path__ + "static/media/18c-01-HOME_barro.c929e190.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18c/18c-01-HOME_barro.jpg
// module id = 228
// module chunks = 0